import { ShieldCheck, BadgeCheck, Sparkles } from "lucide-react";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { JsonLogo } from "@/components/JsonLogo";

const TRUST_ICONS = [ShieldCheck, BadgeCheck, Sparkles];

export const HeroSection = () => {
  const { t } = useLanguage();

  const trust = (t.header as any).trust ?? [];

  return (
    <header className="text-center space-y-6 py-12">
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="p-3 bg-primary/10 rounded-xl border border-primary/20">
          <JsonLogo size={32} />
        </div>
      </div>
      <div className="space-y-3">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
          {t.header.heroTitle}{" "}
          <span className="gradient-text">{t.header.heroHighlight}</span>
        </h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          {t.header.subtitle} {t.header.automatically}
          <br />
          {t.header.description}
        </p>
      </div>

      {/* Trust strip: no invented data / verified code / free trial without signup */}
      {trust.length > 0 && (
        <ul className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-3xl mx-auto text-left">
          {trust.map((item: { title: string; desc: string }, i: number) => {
            const Icon = TRUST_ICONS[i % TRUST_ICONS.length];
            return (
              <li
                key={item.title}
                className="flex items-start gap-3 rounded-xl border border-border/60 bg-card/60 px-4 py-3"
              >
                <div className="p-1.5 rounded-lg bg-primary/10 text-primary flex-shrink-0">
                  <Icon className="w-4 h-4" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground">{item.title}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{item.desc}</p>
                </div>
              </li>
            );
          })}
        </ul>
      )}

      <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground mt-4">
        <Sparkles className="w-4 h-4 text-primary" />
        <span>{t.header.badge}</span>
      </div>
    </header>
  );
};
